import React, { useEffect, useMemo, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton, Tabs, Tab } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { RxCross2 } from "react-icons/rx";

import {
  riskCategories,
  riskImpacts,
  riskStatus,
  riskResponsible,
  MitigationactionStatus,
  riskLikelihood,
  impactCategories,
} from "helpers/riskOptions";

import Select from "react-select";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import { useUpdateProjectRiskMutation } from "store/slices/apis/projectRiskSlice";
import ActionTrackerCommentList from "view/actionTracker/ActionTrackerCommentList";
import { useAddActionTrackerMutation } from "store/slices/apis/actionTrackerSlice";
import DocumentManagement from "components/DocumentManagement";
import CustomTabs from "components/CustomTabs";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";
import { useGetAllContactsQuery } from "store/slices/apis/contactSlice";

const rightLabelStyle = {
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "100%",
  color: "#5F5F5F",
  fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
  "& .MuiInputBase-input": {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "100%",
    letterSpacing: "0.16px",
    color: "#0A0A0C",
    fontFamily: "Outfit, sans-serif",
  },
};

const labelTextStyle = {
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "100%",
  color: "#5F5F5F",
  fontFamily: "Outfit, sans-serif",
  mb: 1,
  mt: 1,
};

const calenderSVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_894_610)">
      <path
        d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z"
        fill="#433F5E"
      />
      <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
      <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
      <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
    </g>
    <defs>
      <clipPath id="clip0_894_610">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const tabs = [
  { label: "Risk Detail", value: "Risk Detail" },
  { label: "Mitigation Plan", value: "Mitigation Plan" },
  // { label: "Documents", value: "Documents" }
]

const EditRisk = (props) => {
  const { open, handleClose, rowData, refetchCounts } = props;
  console.log("rowData", rowData)
  const { projectId } = useParams();
  const { projectId: paramProjectId } = useParams();
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);
  const [actionContact, setActionContact] = useState([]);
  const contactListRes = useGetAllContactsQuery();


  useEffect(() => {
    if (contactListRes?.isSuccess) {
      const contacts = contactListRes?.data?.data || [];
      setActionContact(
        mapAndSortAlphabetically(contacts, "name", "email")
      );
      // setActionContact(
      //     contactListRes?.data?.data?.map(item => ({
      //         value: item?.email,
      //         label: item?.name
      //     }))
      // );
    }
  }, [contactListRes])

  const [updateProjectRisk] = useUpdateProjectRiskMutation();
  const [createProjectAction] = useAddActionTrackerMutation();

  const module = "Risk";

  const { data: riskCategoriesRes } = useGetMasterDataQuery({ module: module, category: 'Category', ProjectId: projectId });
  const categoryData = riskCategoriesRes?.data || [];
  const riskCategories = mapAndSortAlphabetically(categoryData);
  // const riskCategories = (categoryData || []).map(p => ({
  //   value: p?.value,
  //   label: p?.value,
  // }));

  // const { data: riskLikelihoodRes } = useGetMasterDataQuery({ module: module, category: 'Likelihood', ProjectId: projectId });
  // const riskLikelihoodData = riskLikelihoodRes?.data || [];
  // const riskLikelihood = (riskLikelihoodData || []).map(p => ({
  //   value: p?.value,
  //   label: p?.value,
  // }));

  // const { data: riskImpactsRes } = useGetMasterDataQuery({ module: module, category: 'Impact', ProjectId: projectId });
  // const riskImpactsData = riskImpactsRes?.data || [];
  // const riskImpacts = (riskImpactsData || []).map(p => ({
  //   value: p?.value,
  //   label: p?.value,
  // }));

  const { data: riskStatusRes } = useGetMasterDataQuery({ module: module, category: 'RiskStatus', ProjectId: projectId });
  const riskStatusData = riskStatusRes?.data || [];
  const riskStatus = (riskStatusData || []).map(p => ({
    value: p?.value,
    label: p?.value,
  }));

  const { data: impactCategoriesRes } = useGetMasterDataQuery({ module: module, category: 'ImpactCategory', ProjectId: projectId });
  const impactCategoriesData = impactCategoriesRes?.data || [];
  const impactCategories = mapAndSortAlphabetically(impactCategoriesData);
  // const impactCategories = (impactCategoriesData || []).map(p => ({
  //   value: p?.value,
  //   label: p?.value,
  // }));

  const { data: riskResponsibleRes } = useGetMasterDataQuery({ module: module, category: 'EntityPersonResponsible', ProjectId: projectId });
  const riskResponsibleData = riskResponsibleRes?.data || [];
  const riskResponsible = mapAndSortAlphabetically(riskResponsibleData);
  // const riskResponsible = (riskResponsibleData || []).map(p => ({
  //   value: p?.value,
  //   label: p?.value,
  // }));

  const { data: MitigationactionStatusRes } = useGetMasterDataQuery({ module: module, category: 'MitigationactionStatus', ProjectId: projectId });
  const MitigationactionStatusData = MitigationactionStatusRes?.data || [];
  const MitigationactionStatus = (MitigationactionStatusData || []).map(p => ({
    value: p?.value,
    label: p?.value,
  }));

  const [actions, setActions] = useState([]);
  const [expandedComments, setExpandedComments] = useState({});


  const { data: actionStatusRes } = useGetMasterDataQuery({ module: "ActionTracker", category: 'Status', ProjectId: paramProjectId });

  const actionStatusData = actionStatusRes?.data || [];
  const actionStatus = (actionStatusData || []).map(p => ({
    value: p?.value,
    label: p?.value,
  }));

  // ---------- helpers ----------
  const openNotification = (msg, type = "error", duration = 3000) => {
    dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: { color: type },
        close: false,
      })
    );
    setTimeout(() => dispatch(closeSnackbar()), duration);
  };

  const computeSeverity = (rating) => {
    const numeric = Number(rating) || 0;
    if (numeric >= 15) return "Critical";
    if (numeric >= 6) return "Moderate";
    return "Low";
  };

  const makeClientId = () =>
    typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;

  // ---------- initialize actions from rowData ----------
  useEffect(() => {
    if (rowData?.projectActions?.length) {
      setActions(
        rowData.projectActions.map((a) => ({
          ...a,
          clientId: a.projectActionId ?? makeClientId(),
          isNew: false,
          isDeleted: false,
          isSaving: false,
          // normalize date field name to dueDate in UI
          dueDate:
            a.dueDate || a.targetClosureDate
              ? moment(a.dueDate || a.targetClosureDate).format("YYYY-MM-DD")
              : "",
        }))
      );
    } else {
      setActions([]);
    }
  }, [rowData]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const toggleComments = (projectActionId) => {
    setExpandedComments((prev) => ({ ...prev, [projectActionId]: !prev[projectActionId] }));
  };

  // ---------- action editing using clientId (NOT index) ----------
  const handleActionChange = (clientId, field, value) => {
    setActions((prev) => prev.map((a) => (a.clientId === clientId ? { ...a, [field]: value } : a)));
  };

  // ---------- add draft row ----------
  const handleAddAction = () => {
    setActions((prev) => [
      ...prev,
      {
        clientId: makeClientId(),
        projectActionId: null,
        description: "",
        topic: "Risk Register", // hardcoded
        status: "Open",
        assignedTo: "",
        dueDate: "",
        isNew: true,
        isDeleted: false,
        isSaving: false,
      },
    ]);
  };

  // ---------- save new action via API (without saving risk) ----------
  const handleSaveNewAction = async (action) => {
    if (!rowData?.projectRiskId) {
      openNotification("Risk Id missing. Please reopen Edit screen.", "error");
      return;
    }
    if (!action.description?.trim()) {
      openNotification("Action description is required", "error");
      return;
    }

    setActions((prev) =>
      prev.map((a) => (a.clientId === action.clientId ? { ...a, isSaving: true } : a))
    );

    // IMPORTANT: adjust key names here if your backend uses different names
    const reqBody = {
      projectId: projectId,
      topic: "Risk Management",
      source: "Risk Register",
      description: action.description,
      assignedTo: action.assignedTo || null,
      status: action.status || "Open",
      dueDate: action.dueDate ? moment(action.dueDate, "YYYY-MM-DD").toISOString() : null,
      riskId: rowData.projectRiskId,
    };

    try {
      const saved = await createProjectAction(reqBody).unwrap();

      // assume API returns projectActionId; if it returns "id" change below
      const newId = saved?.projectActionId ?? saved?.id ?? null;

      setActions((prev) =>
        prev.map((a) =>
          a.clientId === action.clientId
            ? {
              ...a,
              ...saved,
              projectActionId: newId,
              isNew: false,
              isSaving: false,
              isDeleted: false,
              // keep UI date as YYYY-MM-DD
              dueDate: a.dueDate,
              clientId: newId ?? a.clientId,
            }
            : a
        )
      );

      openNotification("Action created", "success");
    } catch (e) {
      openNotification(e?.error ?? "Failed to create action", "error");
      setActions((prev) =>
        prev.map((a) => (a.clientId === action.clientId ? { ...a, isSaving: false } : a))
      );
    }
  };

  // ---------- delete row (draft remove OR soft delete locally) ----------
  const handleDeleteAction = (action) => {
    setActions((prev) => {
      // if brand new (not saved), remove from UI
      if (action.isNew && !action.projectActionId) {
        return prev.filter((a) => a.clientId !== action.clientId);
      }
      // otherwise mark deleted (you can later wire delete API)
      return prev.map((a) => (a.clientId === action.clientId ? { ...a, isDeleted: true } : a));
    });
  };

  // ---------- form data ----------
  const [formData, setFormData] = useState({
    category: rowData?.category || "",
    riskStatus: rowData?.riskStatus || "",
    title: rowData?.title || "",
    riskRating: rowData?.riskRating || "",
    severity: rowData?.severity || "",
    mitigationActionStatus: rowData?.mitigationActionStatus || "",
    targetClosureDate: moment(rowData?.targetClosureDate)?.format("YYYY-MM-DD") || "",
    entityPersonResponsible: rowData?.entityPersonResponsible || "",
    description: rowData?.description || "",
    riskOwner: rowData?.riskOwner || "",
    dateIdentified: moment(rowData?.dateIdentified)?.format("YYYY-MM-DD") || "",
    likelihood: rowData?.likelihood || "",
    impact: rowData?.impact || "",
    impactCategory: rowData?.impactCategory || "",
    mitigationPlan: rowData?.mitigationPlan || "",
    projectId: projectId,
  });

  // keep formData in sync when rowData changes
  useEffect(() => {
    setFormData({
      category: rowData?.category || "",
      riskStatus: rowData?.riskStatus || "",
      title: rowData?.title || "",
      riskRating: rowData?.riskRating || "",
      severity: rowData?.severity || "",
      mitigationActionStatus: rowData?.mitigationActionStatus || "",
      targetClosureDate: moment(rowData?.targetClosureDate)?.format("YYYY-MM-DD") || "",
      entityPersonResponsible: rowData?.entityPersonResponsible || "",
      description: rowData?.description || "",
      riskOwner: rowData?.riskOwner || "",
      dateIdentified: moment(rowData?.dateIdentified)?.format("YYYY-MM-DD") || "",
      likelihood: rowData?.likelihood || "",
      impact: rowData?.impact || "",
      impactCategory: rowData?.impactCategory || "",
      mitigationPlan: rowData?.mitigationPlan || "",
      projectId: projectId,
    });
  }, [rowData, projectId]);

  const validationSchema = Yup.object({
    category: Yup.string().required("Category field is required"),
    riskStatus: Yup.string().required("Status field is required"),
    title: Yup.string().required("Title field is required"),
    riskRating: Yup.string().required("Risk Rating field is required"),
    severity: Yup.string().required("Severity field is required"),
    // mitigationActionStatus: Yup.string().required("Mitigation Action Status field is required"),
    // targetClosureDate: Yup.date().required("Target Closure Date field is required"),
    // entityPersonResponsible: Yup.string().required("Entity/Person Responsible field is required"),
    description: Yup.string().required("Description field is required"),
    dateIdentified: Yup.date().required("Date Identified field is required"),
    riskOwner: Yup.string().required("Risk Owner field is required"),
    likelihood: Yup.string().required("Likelihood field is required"),
    impact: Yup.string().required("Impact field is required"),
    impactCategory: Yup.string().required("Impact Category field is required"),
    // mitigationPlan: Yup.string().required("Mitigation Plan field is required"),
  });

  // ---------- risk save (NO actions payload) ----------
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const reqBody = {
      projectRiskId: rowData?.projectRiskId,
      projectId: projectId,
      category: values?.category,
      title: values?.title,
      description: values?.description,
      dateIdentified: moment(values?.dateIdentified)?.toISOString(),
      riskOwner: values?.riskOwner,
      likelihood: Number(values?.likelihood),
      impact: Number(values?.impact),
      riskRating: Number(values?.riskRating),
      severity: values?.severity,
      impactCategory: values?.impactCategory,
      riskStatus: values?.riskStatus,
      mitigationPlan: values?.mitigationPlan,
      mitigationActionStatus: values?.mitigationActionStatus,
      targetClosureDate: moment(values?.targetClosureDate)?.toISOString(),
      entityPersonResponsible: values?.entityPersonResponsible,
      remarks: "Project Risks",
      isActive: true,
    };

    try {
      await updateProjectRisk({ body: reqBody }).unwrap();
      openNotification("Project risk updated successfully", "success");

      resetForm();
      refetchCounts();
      setSubmitting(false);
      handleClose();
    } catch (error) {
      openNotification(error?.error ?? "Something went wrong", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      fullScreen
      PaperProps={{
        sx: {
          borderTopLeftRadius: "5px",
          borderTopRightRadius: "5px",
          backgroundColor: "#FFFFFF",
          width: "100%",
          overflowX: "hidden",
        },
      }}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #ddd",
          backgroundColor: "#ECECEC",
          pb: 2,
          pt: 3,
          width: "100%",
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "27px",
            lineHeight: "100%",
            color: "#140F36",
            fontFamily: "Outfit, sans-serif",
          }}
        >
          Edit Risk
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            p: 2,
            mb: 3,
            backgroundColor: "#FFFFFF",
          }}
        >
          <Grid container spacing={2}>
            {/* LEFT: Risk form */}
            <Grid size={12}>
              <CustomTabs tabs={tabs} handleTabChange={handleTabChange} tabValue={tabValue} />
            </Grid>
            {tabValue == 0 &&
              <Grid size={{ md: 12, xs: 12 }}>
                <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize>
                  {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setFieldTouched }) => (
                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={2}>
                        <Grid size={12}>
                          <Typography sx={{ mt: 1, mb: 0, fontSize: "22px", fontWeight: 500, fontFamily: "Outfit, sans-serif", color: "#0A0A0C" }}>
                            Risk Details
                          </Typography>
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>Select Category</Typography>
                          <Select
                            name="category"
                            options={riskCategories}
                            value={riskCategories.find((opt) => opt.value === String(values.category)) || null}
                            onChange={(option) => setFieldValue("category", option.value)}
                            onBlur={() => setFieldTouched("category", true)}
                            placeholder="Select Category"
                          />
                          {touched.category && errors.category && <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>{errors.category}</Typography>}
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <Typography sx={labelTextStyle}>Title</Typography>
                          <TextField fullWidth name="title" value={values.title} onChange={handleChange} onBlur={handleBlur} placeholder="Enter Risk Title" />
                          {touched.title && errors.title && <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>{errors.title}</Typography>}
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>Date Identified</Typography>
                          <TextField
                            type="date"
                            name="dateIdentified"
                            value={values.dateIdentified}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onClick={(e) => {
                              const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                              if (input) input.showPicker?.();
                            }}
                            fullWidth
                            sx={{
                              ...rightTextStyle,
                              "& input::-webkit-calendar-picker-indicator": { display: "none", WebkitAppearance: "none" },
                              "& input[type='date']": { appearance: "none", WebkitAppearance: "none" },
                              "& .MuiOutlinedInput-root": { "& fieldset": { border: "none" } },
                            }}
                            InputProps={{
                              startAdornment: <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>{calenderSVG}</Box>,
                              sx: { backgroundColor: "#fff", border: "1px solid", borderColor: "hsl(0, 0%, 80%)", height: "40px", borderRadius: "5px" },
                            }}
                          />
                          {touched.dateIdentified && errors.dateIdentified && <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>{errors.dateIdentified}</Typography>}
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <Typography sx={labelTextStyle}>Risk Owner</Typography>
                          {/* <TextField fullWidth name="riskOwner" value={values.riskOwner} onChange={handleChange} onBlur={handleBlur} placeholder="Enter Risk Owner" /> */}
                          <Select
                            name="riskOwner"
                            options={riskResponsible}
                            value={riskResponsible.find(opt => opt.value === String(values.riskOwner)) || null}
                            onChange={(option) => setFieldValue("riskOwner", option.value)}
                            onBlur={() => setFieldTouched("riskOwner", true)}
                            placeholder="Select Risk Owner"
                          />
                          {touched.riskOwner && errors.riskOwner && <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>{errors.riskOwner}</Typography>}
                        </Grid>


                        <Grid size={{ xs: 12, md: 8 }}>
                          <Typography sx={labelTextStyle}>Description</Typography>
                          <TextField fullWidth name="description" value={values.description} onChange={handleChange} onBlur={handleBlur} multiline rows={3} placeholder="Enter Risk Description" />
                          {touched.description && errors.description && <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>{errors.description}</Typography>}
                        </Grid>

                        <Grid size={12}>
                          <Typography sx={{ mt: 1, mb: 0, fontSize: "22px", fontWeight: 500, fontFamily: "Outfit, sans-serif", color: "#0A0A0C" }}>
                            Risk Assessment
                          </Typography>
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>Likelihood</Typography>
                          <Select
                            name="likelihood"
                            options={riskLikelihood}
                            value={riskLikelihood.find((opt) => opt.value === String(values.likelihood)) || null}
                            onChange={(option) => {
                              const likelihood = Number(option.value) || 0;
                              const impact = Number(values.impact) || 0;
                              const rating = likelihood * impact;
                              setFieldValue("likelihood", option.value);
                              setFieldValue("riskRating", rating);
                              setFieldValue("severity", computeSeverity(rating));
                            }}
                            onBlur={() => setFieldTouched("likelihood", true)}
                            placeholder="Select Likelihood"
                          />
                          {touched.likelihood && errors.likelihood && <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>{errors.likelihood}</Typography>}
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>Select Risk Impact</Typography>
                          <Select
                            name="impact"
                            options={riskImpacts}
                            value={riskImpacts.find((opt) => opt.value === String(values.impact)) || null}
                            onChange={(option) => {
                              const impact = Number(option.value) || 0;
                              const likelihood = Number(values.likelihood) || 0;
                              const rating = likelihood * impact;
                              setFieldValue("impact", option.value);
                              setFieldValue("riskRating", rating);
                              setFieldValue("severity", computeSeverity(rating));
                            }}
                            onBlur={() => setFieldTouched("impact", true)}
                            placeholder="Select Risk Impact"
                          />
                          {touched.impact && errors.impact && <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>{errors.impact}</Typography>}
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <Typography sx={labelTextStyle}>Risk Rating</Typography>
                          <TextField fullWidth name="riskRating" value={values.riskRating} InputProps={{ readOnly: true }} placeholder="Auto-calculated" />
                          {touched.riskRating && errors.riskRating && <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>{errors.riskRating}</Typography>}
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>Select Severity</Typography>
                          <TextField fullWidth name="severity" value={values.severity} InputProps={{ readOnly: true }} placeholder="Auto-calculated" />
                          {touched.severity && errors.severity && <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>{errors.severity}</Typography>}
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>Impact Category</Typography>
                          <Select
                            name="impactCategory"
                            options={impactCategories}
                            value={impactCategories.find((opt) => opt.value === values.impactCategory) || null}
                            onChange={(option) => setFieldValue("impactCategory", option.value)}
                            onBlur={() => setFieldTouched("impactCategory", true)}
                            placeholder="Select Impact Category"
                          />
                          {touched.impactCategory && errors.impactCategory && <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>{errors.impactCategory}</Typography>}
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>Risk Status</Typography>
                          <Select
                            name="riskStatus"
                            options={riskStatus}
                            value={riskStatus.find((opt) => opt.value === values.riskStatus) || null}
                            onChange={(option) => setFieldValue("riskStatus", option.value)}
                            onBlur={() => setFieldTouched("riskStatus", true)}
                            placeholder="Select Status"
                          />
                          {touched.riskStatus && errors.riskStatus && <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>{errors.riskStatus}</Typography>}
                        </Grid>

                        {
                          rowData?.mitigationActionStatus &&
                          rowData.targetClosureDate &&
                          rowData.entityPersonResponsible &&
                          rowData.mitigationPlan && (
                            <>
                              <Grid size={12}>
                                <Typography sx={{ mt: 1, mb: 0, fontSize: "22px", fontWeight: 500, fontFamily: "Outfit, sans-serif", color: "#0A0A0C" }}>
                                  Risk Response Planning
                                </Typography>
                              </Grid>

                              <Grid size={{ xs: 12, md: 4 }}>
                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>Mitigation Action Status</Typography>
                                <Select
                                  name="mitigationActionStatus"
                                  options={MitigationactionStatus}
                                  value={
                                    MitigationactionStatus.find(
                                      (opt) => opt.value.toLowerCase() === String(values.mitigationActionStatus).toLowerCase()
                                    ) || null
                                  }
                                  onChange={(option) => setFieldValue("mitigationActionStatus", option.value)}
                                  isDisabled={true}
                                  onBlur={() => setFieldTouched("mitigationActionStatus", true)}
                                  placeholder="Select Mitigation Action Status"
                                />
                                {touched.mitigationActionStatus && errors.mitigationActionStatus && (
                                  <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                    {errors.mitigationActionStatus}
                                  </Typography>
                                )}
                              </Grid>

                              <Grid size={{ xs: 12, md: 4 }}>
                                <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>Target Closure Date</Typography>
                                <TextField type="date" name="targetClosureDate" value={values.targetClosureDate} onChange={handleChange} onBlur={handleBlur} fullWidth disabled />
                                {touched.targetClosureDate && errors.targetClosureDate && (
                                  <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                    {errors.targetClosureDate}
                                  </Typography>
                                )}
                              </Grid>

                              <Grid size={{ xs: 12, md: 4 }}>
                                <Typography sx={labelTextStyle}>Entity Person Responsible</Typography>
                                <Select
                                  name="entityPersonResponsible"
                                  options={riskResponsible}
                                  value={riskResponsible.find((opt) => opt.value === values.entityPersonResponsible) || null}
                                  onChange={(option) => setFieldValue("entityPersonResponsible", option.value)}
                                  isDisabled={true}
                                  onBlur={() => setFieldTouched("entityPersonResponsible", true)}
                                  placeholder="Select Responsible / Owner"
                                />
                                {touched.entityPersonResponsible && errors.entityPersonResponsible &&
                                  <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>{errors.entityPersonResponsible}</Typography>}
                              </Grid>

                              <Grid size={{ xs: 12, md: 12 }}>
                                <Typography sx={labelTextStyle}>Mitigation Plan</Typography>
                                <TextField fullWidth name="mitigationPlan" value={values.mitigationPlan} onChange={handleChange} onBlur={handleBlur} multiline rows={3} placeholder="Enter Mitigation Plan Description" InputProps={{
                                  readOnly: true
                                }} />
                                {touched.mitigationPlan && errors.mitigationPlan && (
                                  <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                    {errors.mitigationPlan}
                                  </Typography>
                                )}
                              </Grid>
                            </>
                          )

                        }



                        <Grid size={12}>
                          <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                            <Button onClick={handleClose} sx={{ textTransform: "none", color: "#F15744", fontSize: "14px", fontFamily: "Outfit, sans-serif", borderRadius: "25px", fontWeight: 500, px: "20px", py: "15px" }}>
                              Cancel
                            </Button>
                            <Button type="submit" variant="contained" disabled={isSubmitting} sx={{ backgroundColor: "#00344C", borderRadius: "25px", textTransform: "none", fontWeight: 500, fontSize: "14px", fontFamily: "Outfit, sans-serif", color: "#FFFFFF", px: "20px", py: "15px", ml: 1 }}>
                              {isSubmitting ? "Saving..." : "Save"}
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </form>
                  )}
                </Formik>
              </Grid>
            }
            {/* RIGHT: Actions */}
            {tabValue == 1 &&
              <Grid size={{ md: 12, xs: 12 }}>
                <Box sx={{ borderLeft: "2px solid #e0e0e0", p: 2, backgroundColor: "#FFFFFF", height: "90vh", display: "flex", flexDirection: "column" }}>
                  <Box sx={{ mb: 1 }}>
                    <Typography sx={{ fontSize: "22px", fontWeight: 500, fontFamily: "Outfit, sans-serif", color: "#0A0A0C" }}>
                      Mitigation Plan ( Action tracker item)
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
                    <Button startIcon={<AddIcon />} onClick={handleAddAction} sx={{ textTransform: "none", borderRadius: "3px", fontFamily: "Outfit, sans-serif" }} size="small" type="button">
                      Add Action
                    </Button>
                  </Box>

                  <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
                    {actions.filter((a) => !a.isDeleted).length === 0 && (
                      <Typography sx={{ fontSize: "14px", color: "#777", fontFamily: "Outfit, sans-serif" }}>
                        No actions added yet.
                      </Typography>
                    )}

                    {actions
                      .filter((a) => !a.isDeleted)
                      .map((action) => {
                        const isExpanded = action.projectActionId ? expandedComments[action.projectActionId] : false;

                        return (
                          <Box
                            key={action.clientId}
                            sx={{ border: "1px solid #e0e0e0", p: 2, mb: 2 }}
                          >
                            <Grid container spacing={2}>
                              <Grid size={{ xs: 12 }}>
                                <Typography sx={labelTextStyle}>Description</Typography>
                                <TextField
                                  fullWidth
                                  size="small"
                                  value={action.description || ""}
                                  onChange={(e) => handleActionChange(action.clientId, "description", e.target.value)}
                                />
                              </Grid>

                              <Grid size={{ xs: 12, md: 4 }}>
                                <Typography sx={labelTextStyle}>Status</Typography>
                                {/* <TextField
                                  fullWidth
                                  size="small"
                                  value={action.status || ""}
                                  onChange={(e) => handleActionChange(action.clientId, "status", e.target.value)}
                                /> */}
                                <Select
                                  name="status"
                                  options={actionStatus}
                                  value={actionStatus.find(opt => opt.value === action.status) || null}
                                  onChange={(option) => {
                                    handleActionChange(action.clientId, "status", option.value);

                                    // optional logic
                                    if (option.value !== "Closed") {
                                      handleActionChange(action.clientId, "closedDate", "");
                                    }
                                  }}
                                  placeholder="Select Status"
                                />
                              </Grid>

                              <Grid size={{ xs: 12, md: 4 }}>
                                <Typography sx={labelTextStyle}>Assignee</Typography>
                                {/* <TextField
                                  fullWidth
                                  size="small"
                                  value={action.assignedTo || ""}
                                  onChange={(e) => handleActionChange(action.clientId, "assignedTo", e.target.value)}
                                /> */}
                                <Select
                                  name="assignedTo"
                                  options={actionContact}
                                  value={
                                    actionContact.find(
                                      (opt) => opt.value === action.assignedTo
                                    ) || null
                                  }
                                  onChange={(option) =>
                                    handleActionChange(
                                      action.clientId,
                                      "assignedTo",
                                      option.value
                                    )
                                  }
                                  placeholder="Select Assigned To"
                                />
                              </Grid>

                              <Grid size={{ xs: 10, md: 3 }}>
                                <Typography sx={labelTextStyle}>Target Closure Date</Typography>
                                <TextField
                                  type="date"
                                  fullWidth
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  value={action.dueDate || ""}
                                  onChange={(e) => handleActionChange(action.clientId, "dueDate", e.target.value)}
                                />
                              </Grid>
                              {
                                action.isNew &&
                                <Grid size={{ xs: 2, md: 1 }} sx={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                                  <IconButton onClick={() => handleDeleteAction(action)} size="small">
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Grid>
                              }

                            </Grid>

                            {/* Save button for NEW actions only */}
                            {action.isNew && !action.projectActionId && (
                              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                                <Button
                                  size="small"
                                  variant="contained"
                                  disabled={action.isSaving}
                                  onClick={() => handleSaveNewAction(action)}
                                  sx={{ textTransform: "none" }}
                                >
                                  {action.isSaving ? "Saving..." : "Save Action"}
                                </Button>
                              </Box>
                            )}

                            {/* Comments toggle only for saved actions */}
                            {action.projectActionId && (
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                                <Button
                                  size="small"
                                  onClick={() => toggleComments(action.projectActionId)}
                                  sx={{ textTransform: "none", fontSize: "13px", fontFamily: "Outfit, sans-serif", paddingLeft: 0 }}
                                >
                                  {isExpanded ? "Hide comments" : "View comments"}
                                </Button>
                              </Box>
                            )}

                            {isExpanded && action.projectActionId && (
                              <Box sx={{ mt: 1, pl: 1, borderTop: "1px dashed #ddd", pt: 1 }}>
                                <ActionTrackerCommentList data={action} />
                              </Box>
                            )}
                          </Box>
                        );
                      })}
                  </Box>
                </Box>
              </Grid>
            }
            {tabValue == 2 &&
              <Grid size={{ md: 12, xs: 12 }}>
                <DocumentManagement id={rowData?.projectRiskId} entityType="Risk" customId={rowData?.customId} />
              </Grid>
            }
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default EditRisk;
